import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { BulkSms } from '../../pages';
import { BulkSmsController, CustomerController } from '../../controllers';
import { appStore, customerStore, useStores, bulkSmsStore } from '../../stores';
import * as yup from 'yup';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { toJS } from 'mobx';
import { EditSms } from '../../pages'
import moment from 'moment';

const EditSmsContainer = ({
    closeComposeSide,
    tags,
    setTags,
    customers,
    vendors,
    btnClicked,
    sendPayload,
    setSendPayload,
    showComposeSide,
    setBtnClicked,
    showScheduleMsgModal,
    setMsgView,
    setMsgFilterItem,
}) => {
    const [loading, setLoading] = useState(false);

    const selectedMessage = bulkSmsStore.selectedMessage

    const selectAllCustomers = () => {
        const allCustomerNames = customers.map((x) => (x.fullname))
        setTags(tags.concat(allCustomerNames.filter((item) => tags.indexOf(item) < 0)))
    }

    const selectAllVendors = () => {
        const allVendorNames = vendors.map((x) => (x.name))
        setTags(tags.concat(allVendorNames.filter((item) => tags.indexOf(item) < 0)))
    }

    const removeAll = () => {
        setTags([]);
    }

    const selectAllProspects = () => {
        const allProspects = bulkSmsStore.allProspects.map((x) => (x.mobile))
        setTags(tags.concat(allProspects.filter((item) => tags.indexOf(item) < 0)))
    }

    const SmsValidation = () => {
        return yup.object({
            message: yup.string().required('Message is required'),
            mobile: yup.array().required('Customer phone number is required'),
        });
    };

    const onSubmit = async values => {
        const contacts = customers.concat(vendors);
        // const chosenCustomer = customers.filter(customer => tags.includes(customer.fullname))
        const chosenContacts = contacts.filter(contact => tags.includes({a: contact.fullname || contact.name}))

        // const customerNames = chosenCustomer.map((x) => {
        //     return x.fullname
        // })
        const contactNames = chosenContacts.map((x) => {
            return {
                a: x.fullname || x.name
            }
        })

        const contactNumbers = chosenContacts.map((x) => {
            return x.mobile
        })

        const numbersOnly = tags.filter((names) => !contactNames.includes(names))

        const mobileToSend = [...numbersOnly, ...contactNumbers]

        let payload

        if (btnClicked === "scheduleMessageEdit") { 
            setSendPayload({
                mobile: mobileToSend,
                message: values.message,
            })
        }
        

        if (btnClicked === "saveEdit") {
            setLoading(true);          

            if (selectedMessage.status === "DRAFT") {
                payload = {
                    mobile: mobileToSend,
                    message: values.message,
                }
            } 

            if (selectedMessage.status === "SCHEDULED") {

                const scheduledTime = moment(selectedMessage.scheduledTime);

                const scheduledDate = scheduledTime.format("YYYY-MM-DD");
                const scheduledHour = scheduledTime.format("HH");
                const scheduledMinute = scheduledTime.format("mm");   

                    payload = {                
                    mobile: mobileToSend,
                    message: values.message,
                    scheduledDate: scheduledDate,
                    scheduledHour: scheduledHour,
                    scheduledMinute: scheduledMinute,
                }
            }

            const messageId = selectedMessage._id;

            const { status, errorMessage } = await BulkSmsController.editSms(messageId, payload);
            if (status === constant.Success) {
                setLoading(false);
                MimaToastUtil.success({
                    message: constant.Success,
                });
                closeComposeSide();
                setTags([]);

                if (selectedMessage.status === "DRAFT") {
                    setMsgView("Drafts")
                    setMsgFilterItem("DRAFT")
                }

                if (selectedMessage.status === "SCHEDULED") {
                    setMsgView("Scheduled Messages")
                    setMsgFilterItem("SCHEDULED")
                }


            } else {
                setLoading(false);
                return MimaToastUtil.error({
                    message: errorMessage,
                });
            }
        }
    };

    return (
        <EditSms
            closeComposeSide={closeComposeSide}
            SmsValidation={SmsValidation}
            onSubmit={onSubmit}
            tags={tags}
            setTags={setTags}
            customers={customers}
            vendors={vendors}
            btnClicked={btnClicked}
            setBtnClicked={setBtnClicked}
            showScheduleMsgModal={showScheduleMsgModal}
            selectAllProspects={selectAllProspects}
            selectAllCustomers={selectAllCustomers}
            selectAllVendors={selectAllVendors}
            loading={loading}
            selectedMessage={selectedMessage}
            removeAll={removeAll}
        />
    )
}

export default EditSmsContainer